import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const token = localStorage.getItem('token');

    if (!token && process.env.REACT_APP_INSTALLATION_MODE !== 'desktop') {
        const redirectPath = encodeURIComponent(
            location.pathname + '?' + searchParams
        );

        return <Navigate to={`/login?redirectTo=${redirectPath}`} replace />;
    }

    return children;
};

export default ProtectedRoute;
